<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with horizontal navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Centered -->
<centered-layout *ngIf="layout === 'centered'"></centered-layout>

<!-- Enterprise -->
<enterprise-layout *ngIf="layout === 'enterprise'"></enterprise-layout>

<!-- Material -->
<material-layout *ngIf="layout === 'material'"></material-layout>

<!-- Modern -->
<modern-layout *ngIf="layout === 'modern'"></modern-layout>

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Layouts with vertical navigation -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- Basic -->
<basic-layout *ngIf="layout === 'basic'"></basic-layout>

<!-- Classic -->
<classic-layout *ngIf="layout === 'classic'"></classic-layout>

<!-- Classy -->
<classy-layout *ngIf="layout === 'classy'"></classy-layout>

<!-- Compact -->
<compact-layout *ngIf="layout === 'compact'"></compact-layout>

<!-- Dense -->
<dense-layout *ngIf="layout === 'dense'"></dense-layout>

<!-- Futuristic -->
<futuristic-layout *ngIf="layout === 'futuristic'"></futuristic-layout>

<!-- Thin -->
<thin-layout *ngIf="layout === 'thin'"></thin-layout>


<div *ngIf="dialerEnable" class="dialer-side-panel">
    <button [attr.guide]="'layout-btn-1' + '__' + sanitizeUrl(url)" class="close-button" (click)="closeDialer()">×</button>
    <iframe name="myDialerFrame" #myHelloSendFrame [src]="iframeUrl | safe: 'resourceUrl'"
        allow="microphone *; autoplay *; display-capture *" width="100%" height="100%" frameborder="0"
        (load)="onIframeLoaded()">
    </iframe>
</div>

<!-- ===================================================================================== -->
<!-- FreJun Global Dialer (dialerType == 12)                                              -->
<!-- Single iframe ALWAYS in DOM (no *ngIf) — CSS-only visibility — never reloads        -->
<!-- ===================================================================================== -->
<ng-container *ngIf="dialerType == 12">

    <!-- Outer wrapper: CSS display toggle only. NO *ngIf so the iframe inside never unmounts. -->
    <div id="frejun-dialer-container"
         [style.display]="frejunDialerVisible ? 'flex' : 'none'"
         [style.height.px]="frejunWidgetHeight || 550"
         style="position: fixed; bottom: 15px; right: 15px; z-index: 99999;
                flex-direction: column; width: 373px; background: #ffffff;
                border-radius: 12px; box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                border: 1px solid rgba(0,0,0,0.08); overflow: hidden; transition: height 0.2s ease;">

        <!-- Header bar -->
        <div style="background: linear-gradient(135deg, #1e293b, #0f172a); color: #fff;
                    padding: 10px 14px; display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;">
            <div style="display: flex; align-items: center; gap: 8px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #38bdf8;">call</mat-icon>
                <span style="font-weight: 600; font-size: 14px; letter-spacing: 0.3px;">FreJun Dialer</span>
            </div>
            <div style="display: flex; align-items: center; gap: 4px;">
                <!-- Re-authorize button — shown only when auth failed/required -->
                <button *ngIf="frejunAuthRequired" type="button" mat-icon-button
                        style="color: #facc15; width: 28px; height: 28px; line-height: 28px;"
                        matTooltip="Re-Authorize FreJun"
                        (click)="frejunHandleAuthorization()">
                    <mat-icon style="font-size: 16px; width: 16px; height: 16px;">verified_user</mat-icon>
                </button>
                <button type="button" mat-icon-button
                        style="color: #94a3b8; width: 28px; height: 28px; line-height: 28px;"
                        matTooltip="Close"
                        (click)="frejunDialerVisible = false">
                    <mat-icon style="font-size: 18px; width: 18px; height: 18px;">close</mat-icon>
                </button>
            </div>
        </div>

        <!-- Auth Error Banner (if any error reported by FreJun) -->
        <div *ngIf="frejunAuthErrorDetail" style="background: #fef2f2; color: #991b1b; padding: 6px 12px; font-size: 12px; border-bottom: 1px solid #fecaca; display: flex; align-items: center; justify-content: space-between;">
            <span>⚠️ <strong>FreJun Error:</strong> {{ frejunAuthErrorDetail }}</span>
            <button type="button" (click)="frejunAuthErrorDetail = ''" style="background: none; border: none; color: #991b1b; cursor: pointer; font-size: 14px; line-height: 1;">×</button>
        </div>

        <!-- Dialer iframe — single instance, always present in DOM -->
        <div style="width: 100%; flex: 1; background: #fafafa; position: relative;">
            <iframe id="frejun-global-iframe"
                    src="https://dialer.frejun.com/"
                    allow="microphone"
                    style="width: 100%; height: 100%; border: none;">
            </iframe>
        </div>
    </div>

</ng-container>